(function (global) {
  'use strict';

  var CHANNEL_NAME = 'QipaoNative';
  var DEFAULT_TIMEOUT_MS = 15000;

  var METHODS = {
    PUBLISH_FROM_ASSETS: 'publish.fromAssets',
    PUBLISH_FROM_ALBUM: 'publish.fromAlbum',
    SHARE_PANEL: 'share.panel',
    SHARE_POST: 'share.post',
    OPEN_VIDEO_DETAIL: 'video.openDetail',
    OPEN_APP_PAGE: 'app.openPage',
    SHARE_OPEN: 'share.open',
    PING: 'bridge.ping',
  };

  function nowId() {
    return (
      'qipao_' +
      Date.now().toString(36) +
      '_' +
      Math.random().toString(36).slice(2)
    );
  }

  function isObject(v) {
    return v !== null && typeof v === 'object' && !Array.isArray(v);
  }

  function safeJsonParse(s) {
    try {
      return JSON.parse(s);
    } catch (_) {
      return null;
    }
  }

  function getChannel() {
    var ch = global && global[CHANNEL_NAME];
    if (ch && typeof ch.postMessage === 'function') return ch;
    var wk = global && global.webkit;
    var mh = wk && wk.messageHandlers;
    var handler = mh && mh[CHANNEL_NAME];
    if (handler && typeof handler.postMessage === 'function') {
      return {
        postMessage: function (message) {
          handler.postMessage(message);
        },
      };
    }
    return null;
  }

  var pending = Object.create(null);

  function fulfillPending(id, payload, isError) {
    var item = pending[id];
    if (!item) return;
    clearTimeout(item.t);
    delete pending[id];
    if (isError) item.reject(payload);
    else item.resolve(payload);
  }

  function invoke(method, params, options) {
    var opts = isObject(options) ? options : {};
    var timeoutMs =
      typeof opts.timeoutMs === 'number' ? opts.timeoutMs : DEFAULT_TIMEOUT_MS;

    return new Promise(function (resolve, reject) {
      var ch = getChannel();
      if (!ch) {
        reject({
          ok: false,
          code: 'NO_CHANNEL',
          message: 'Native channel not found: ' + CHANNEL_NAME,
        });
        return;
      }

      var id = nowId();
      var message = {
        id: id,
        method: method,
        params: params === undefined ? null : params,
      };

      var timer = setTimeout(function () {
        fulfillPending(id, {
          ok: false,
          code: 'TIMEOUT',
          message: 'Timeout: ' + method,
        }, true);
      }, timeoutMs);

      pending[id] = { resolve: resolve, reject: reject, t: timer };

      try {
        ch.postMessage(JSON.stringify(message));
      } catch (e) {
        clearTimeout(timer);
        delete pending[id];
        reject({
          ok: false,
          code: 'POST_FAILED',
          message: String(e && e.message ? e.message : e),
        });
      }
    });
  }

  function handleNativeCallback(payload) {
    var msg = payload;
    if (typeof payload === 'string') {
      msg = safeJsonParse(payload);
    }
    if (!msg || !msg.id) return;
    var ok = msg.ok !== false;
    if (ok) fulfillPending(msg.id, msg, false);
    else fulfillPending(msg.id, msg, true);
  }

  var api = {
    METHODS: METHODS,
    invoke: invoke,
    ping: function (payload) {
      return invoke(METHODS.PING, payload || null);
    },
    publishFromAssets: function (payload) {
      return invoke(METHODS.PUBLISH_FROM_ASSETS, payload || null);
    },
    publishFromAlbum: function (payload) {
      return invoke(METHODS.PUBLISH_FROM_ALBUM, payload || null);
    },
    openSharePanel: function (options) {
      return invoke(METHODS.SHARE_OPEN, options || null);
    },
    sharePost: function (options) {
      return invoke(METHODS.SHARE_POST, options || null);
    },
    openVideoDetail: function (options) {
      return invoke(METHODS.OPEN_VIDEO_DETAIL, options || null);
    },
    openAppPage: function (options) {
      return invoke(METHODS.OPEN_APP_PAGE, options || null);
    },
    openPage: function (options) {
      return invoke(METHODS.OPEN_APP_PAGE, options || null);
    },
    share: function (options) {
      return invoke(METHODS.SHARE_OPEN, options || null);
    },
    legacyShareOpen: function (options) {
      return invoke(METHODS.SHARE_OPEN, options || null);
    },
    _handleNativeCallback: handleNativeCallback,
    _channelName: CHANNEL_NAME,
  };

  Object.defineProperty(api, 'isSupported', {
    enumerable: true,
    get: function () {
      return !!getChannel();
    },
  });

  global.QipaoBridge = api;
})(typeof window !== 'undefined' ? window : this);
